import React, { Component } from 'react';

class TabletEquipment22 extends Component {
    render() {
        return (
            <div>
                <h1>사출기 22호기</h1>
            </div>
        );
    }
}

export default TabletEquipment22;